import { Avatar, List } from "antd";
import React from "react";
import { MessageOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";

import { useTranslation } from "react-i18next";
const Activities = () => {
  const { t } = useTranslation("dashboard");
  const data = [
    {
      icon: <MessageOutlined />,
      content: "You sent 1 Message to the contact.",
      time: "10:25 pm"
    },
    {
      icon: <PhoneOutlined />,
      content: "Denwar responded to your appointment schedule question by call at 09:30pm.",
      time: "09:25 pm"
    },
    {
      icon: <UserOutlined />,
      content: "Meeting With Abraham - Scheduled on 05:00 pm",
      time: "15 Feb 2024"
    }
  ];

  return (
    <div className="activity-section">
      <h3>{t("Activities")}</h3>
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar icon={item.icon} />}
              title={item.content}
              description={item.time}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default Activities;
